module.exports = __webpack_public_path__ + "static/media/wayfinder.e2ca1170.svg";